// 阅卷路由
const judges = [
  {
    path: '/judge',
    redirect: '/judge/select'
  },
  {
    path: '/judge',
    component: () => import('@/views/Judge/index.vue' /* webpackChunkName: "user" */),
    children: [
      {
        path: 'login',
        name: 'login', // 占用之前的逻辑
        component: () => import('@/views/Judge/Login' /* webpackChunkName: "judgeLogin" */),
        meta: {
          layout: 'Noop'
        }
      },
      {
        path: 'select',
        name: 'judgeSelect',
        component: () => import('@/views/Judge/Select' /* webpackChunkName: "judgeList" */),
        meta: {
          layout: 'Noop',
          needLogin: true
        }
      },
      {
        path: 'list',
        name: 'judgeList',
        component: () => import('@/views/Judge/List' /* webpackChunkName: "judgeList" */),
        meta: {
          layout: 'Noop',
          needLogin: true
        }
      },
      {
        path: 'record',
        name: 'judgeRecord',
        component: () => import('@/views/Judge/Record' /* webpackChunkName: "judgeRecord" */),
        meta: {
          layout: 'Noop',
          needLogin: true
        }
      },
      {
        path: 'examinee',
        name: 'judgeExaminee',
        component: () => import('@/views/Judge/ExamineeMode' /* webpackChunkName: "judgeExaminee" */),
        meta: {
          layout: 'Noop',
          needLogin: true
        }
      },
      {
        path: 'preview',
        name: 'judgePreview',
        component: () => import('@/views/Judge/WorkPreview' /* webpackChunkName: "judgePreview" */),
        meta: {
          layout: 'Noop'
        }
      }
    ],
    meta: {
      needLogin: true
    }
  }
]

export default judges
